import styled from "@emotion/styled";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  ListItemText,
} from "@mui/material";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import ProfileService from "services/ProfileService";
import { AuthData } from "auth/AuthWarpper";
import ViewButton from "utils/ViewButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ImportService from "services/ImportService";

const validationSchema = Yup.object({
  profileCode: Yup.string()
    .required("Profile Code is required")
    .max(50, "Profile Code must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Code is required and must not contain Extra spaces"
    ),
  profileName: Yup.string()
    .required("Profile Name is required")
    .max(50, "Profile Name must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Name is required and must not contain Extra spaces"
    ),
  profileAttributes: Yup.string().required("Attribute is required"),
  functionality: Yup.array()
    .min(1, "At least one item is required")
    .required("Functionality is required"),
});

const columns = [
  {
    field: "levelCode",
    headerName: "Level Code",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "locationName",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "parentLocationCode",
    headerName: "Parent Location Code",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "personName",
    headerName: "Person Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "batOneId",
    headerName: "BAT One Id",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "operation",
    headerName: "Operation",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "errorDescription",
    headerName: "Error Description",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "actions",
    type: "actions",
    headerName: "View Details",
    width: 250,
    headerAlign: "left",
    align: "left",
    getActions: (params) => {
      const state = {
        id: params.id,
        levelCode: params.row.levelCode,
        locationName: params.row.locationName,
        parentLocationCode: params.row.parentLocationCode,
        personName: params.row.personName,
        batOneId: params.row.batOneId,
        status: params.row.status,
        operation: params.row.operation,
        errorDescription: params.row.errorDescription,
      };
      const url = `/viewDetails/${params.id}`;
      return [<ViewButton state={state} url={url} />];
    },
  },
];

const ViewContractDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const { user } = AuthData();
  const [options, setOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  let year = "";
  const [yearReload, setYearReload] = useState(false);
  // const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [totalItems, setTotalItems] = useState(5); // Number of items per page
  const [pageSize, setPageSize] = useState(7);
  const contractDetails = {
    operation: "",
    status: "",
    errorDescription: "",
    legacyGrowingNo: "",
    legacyContractNO: "",
    curingTobaccoType: "",
    growerType: "",
    isActive: "",
    totalFarmArea: "",
    cropSeason: "",
    tobaccoType: "",
    biodiversityRisk: "",
    bpm: "",
    cropYear: "",
    tobaccoContractedHectares: "",
    tobaccoPlantedHectares: "",
    propertyFarmNo:"",
  };
  const [contractDetailsData, setContractDetailsData] =
    useState(contractDetails);

  const handleChange = (event) => {
    // setFetchError(false);
    year = event.target.value;
    setYearReload(true);
  };

  const getApiData = (pNumber, size, id) => {
    let entityName = "ImportContract";
    ImportService.FetchLogDetails({
      entityName: entityName,
      pageNumber: pNumber,
      size: size,
      headerID: id,
    })
      .then((res) => {
        let resp = res?.data?.response;
        setContractDetailsData({
          operation: resp?.operation,
          status: resp?.status,
          errorDescription: resp?.errorDescription,
          legacyGrowingNo: resp?.legacyGrowingNo,
          legacyContractNO: resp?.legacyContractNO,
          curingTobaccoType: resp?.curingTobaccoType,
          growerType: resp?.growerType,
          isActive: resp?.isActive,
          totalFarmArea: resp?.totalFarmArea,
          cropSeason: resp?.cropSeason,
          tobaccoType: resp?.tobaccoType,
          biodiversityRisk: resp?.biodiversityRisk,
          bmp: resp?.bmp,
          cropYear: resp?.cropYear,
          tobaccoContractedHectares: resp?.tobaccoContractedHectares,
          tobaccoPlantedHectares: resp?.tobaccoPlantedHectares,
          propertyFarmNo:resp?.propertyFarmNo
        });
        setLoading(false);
      })
      .catch((error) => {
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      });
  };

  const { previousData, edit } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const [formData, setFormData] = useState({
    profileCode: previousData?.profileCode || "",
    profileName: previousData?.profileName || "",
    profileAttributes: previousData?.attributes || "",
    isActive: previousData?.active == "Active" ? true : false || false,
    functionality: selected,
  });

  useEffect(() => {
    if (id) {
      getApiData(0, pageSize, id);
    }
    if (location && location.pathname == "/addProfiles") {
      let p_name = formData.profileName;
      let p_attr = formData.profileAttributes;
      const result =
        mergeFirstCharacters(p_name) + mergeFirstCharacters(p_attr);
      const uniqueNumber = generateUniqueNumber();
      let numberStr = uniqueNumber.toString();
      if (numberStr.charAt(0) == "-") {
        numberStr = numberStr.replace(numberStr[0], "");
      }
      setFormData({
        ...formData,
        ["profileCode"]: `${result.toUpperCase()}${numberStr}`,
      });
    }
  }, [formData.profileName, formData.profileAttributes]);

  const mergeFirstCharacters = (str) => {
    const words = str.split(" ");
    const mergedCharacters = words.map((word) => word.charAt(0)).join("");
    return mergedCharacters;
  };

  function generateUniqueNumber() {
    const timestamp = new Date().getTime();
    const randomNumber = Math.floor(Math.random() * 1000000);
    const uniqueIdentifier = navigator.userAgent;
    const uniqueNumber = hashCode(timestamp + randomNumber + uniqueIdentifier);
    return uniqueNumber;
  }

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return hash;
  }

  useEffect(() => {
    const fetchFunctionalityOptions = async () => {
      try {
        const response = await ProfileService.getFuntionalityOptions();

        if (edit === true) {
          setOptions([
            ...previousData.functionality,
            ...response.data.response.filter(
              (option) =>
                !previousData.functionality.some(
                  (existingOption) =>
                    existingOption.functionalityName ===
                    option.functionalityName
                )
            ),
          ]);

          // Initialize selected countries with countryArr
          const selectedOptions = previousData.functionality.filter((option) =>
            response.data.response.some(
              (selectedOption) =>
                selectedOption.functionalityName === option.functionalityName
            )
          );
          setSelected(selectedOptions);
          setFormData({
            ...formData,
            functionality: selectedOptions,
          });
        } else {
          setOptions(response.data.response);
        }
      } catch (error) {
        console.error("Error fetching functionality options:", error);
      }
    };

    fetchFunctionalityOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        functionality: formData.functionality,
        createdByUser: user?.userName,
        modifiedByUser: user?.userName,
      };

      const response = await ProfileService.createProfileRegistration(payload);

      if (response.status === 201) {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        modifiedByUser: user.userName,
        profileId: id,
        functionality: formData.functionality,
      };

      const response = await ProfileService.updateProfileRegistration(payload);

      if (response.status === 200) {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
      } else {
        console.error("Failed to update form");
        setSeverity("error");
        setMessage("Failed to update form");
        setOpenAlert(true);
        setLoading(false);
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        console.error("An error occurred while submitting the form:", error);
        setSeverity("error");
        setMessage("An error occurred while submitting the form");
        setOpenAlert(true);
      }
    }
    setLoading(false);
  };

  return (
    <Layout title="Agri360 ESG Portal">
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>Import Contracts</Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
        <PaperContainer>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                  Operation
                </InputLabel>
                <Box>
                  <TextField
                    sx={{
                      width: { xs: "100%", md: "100%" },
                      "& .MuiOutlinedInput-root": {
                        height: "50px",
                        "& fieldset": {
                          borderColor: "#102A63 !important", // Default border color
                          borderWidth: "1px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#102A63 !important", // Hover border color
                          borderWidth: "1px",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#102A63", // Focused border color
                          borderWidth: "1px",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f5f7", // Background color for disabled state
                          "& input": {
                            color: "#000000", // Text color for disabled state
                            WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                            opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                            fontWeight: "600",
                            fontSize: "16px",
                          },
                          "& fieldset": {
                            borderColor: "transparent", // Optional: make border invisible when disabled
                          },
                        },
                      },
                    }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    // label={formData.profileCode ? "" : "Operation"}
                    value={contractDetailsData?.operation}
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                  {errors.profileCode && (
                    <FormHelperText error={true}>
                      {errors.profileCode}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                  Status
                </InputLabel>
                <Box>
                  <TextField
                    sx={{
                      width: { xs: "100%", md: "100%" },
                      "& .MuiOutlinedInput-root": {
                        height: "50px",
                        "& fieldset": {
                          borderColor: "#102A63 !important", // Default border color
                          borderWidth: "1px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#102A63 !important", // Hover border color
                          borderWidth: "1px",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#102A63", // Focused border color
                          borderWidth: "1px",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f5f7", // Background color for disabled state
                          "& input": {
                            color: "#000000", // Text color for disabled state
                            WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                            opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                            fontWeight: "600",
                            fontSize: "16px",
                          },
                          "& fieldset": {
                            borderColor: "transparent", // Optional: make border invisible when disabled
                          },
                        },
                      },
                    }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    // label="Status"
                    value={contractDetailsData?.status}
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                  {errors.profileCode && (
                    <FormHelperText error={true}>
                      {errors.profileCode}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "none" },
                  alignItems: "flex-start",
                  flexDirection: "end",
                }}
              >
                <InputLabel
                  sx={{ width: "12rem", minWidth: "12rem" }}
                  htmlFor="my-input"
                >
                  Error Description
                </InputLabel>
                <Box
                  sx={{
                    width: { xs: "100%" },
                  }}
                >
                  <TextField
                    multiline
                    minRows={4} // Adjust as needed for height
                    sx={{
                      width: { xs: "100%" },
                      "& .MuiOutlinedInput-root": {
                        height: "auto", // Set height to auto for multiline
                        "& fieldset": {
                          borderColor: "#102A63 !important", // Default border color
                          borderWidth: "1px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#102A63 !important", // Hover border color
                          borderWidth: "1px",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#102A63", // Focused border color
                          borderWidth: "1px",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f5f7", // Background color for disabled state
                          "& input": {
                            color: "#000000", // Text color for disabled state
                            WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                            opacity: 1, // Ensure opacity is set to 1
                            fontWeight: "600",
                            fontSize: "16px",
                          },
                          "& fieldset": {
                            borderColor: "transparent", // Optional: make border invisible when disabled
                          },
                        },
                      },
                    }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    value={contractDetailsData?.errorDescription}
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                  {errors.profileCode && (
                    <FormHelperText error={true}>
                      {errors.profileCode}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
            </Grid>
          </form>
        </PaperContainer>
        <Box sx={{ mt: 3 }}>
          <PaperContainer>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Grower No
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      // label={formData.profileCode ? "" : "Level Code"}
                      value={contractDetailsData?.legacyGrowingNo}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Property No
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      //label="Contract No"
                      value={contractDetailsData?.propertyFarmNo}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Contract No
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      //label="Contract No"
                      value={contractDetailsData?.legacyContractNO}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Curing Tobacco Type
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      //label={formData.profileCode ? "" : "Location Name"}
                      value={contractDetailsData?.curingTobaccoType}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Grower Type
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="Grower Type"
                      value={contractDetailsData?.growerType}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Active
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      //label="Active"
                      value={contractDetailsData?.isActive == true ? "Y" : "N"}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Total Farm Area
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="Total Farm Area"
                      value={contractDetailsData?.totalFarmArea}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Crop Season
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      // label="Crop Season"
                      value={contractDetailsData?.cropSeason}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Tobacco Type
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      // label="Tobacco Type"
                      value={contractDetailsData?.tobaccoType}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Biodiversity Risk
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      //label="Biodiversity Risk"
                      value={contractDetailsData?.biodiversityRisk}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    BMP
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="BMP"
                      value={contractDetailsData?.bmp}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "12rem" }} htmlFor="my-input">
                    Crop Year
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="Crop Year"
                      value={contractDetailsData?.cropYear}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel
                    sx={{
                      width: "12rem",
                      whiteSpace: "normal", 
                      overflow: "visible", 
                      textOverflow: "unset", 
                      wordBreak: "break-word", 
                    }}
                    htmlFor="my-input"
                  >
                    Tobacco Contracted Hectares
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="Tobacco Hectares"
                      value={contractDetailsData?.tobaccoContractedHectares}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel
                    sx={{
                      width: "12rem",
                      whiteSpace: "normal", 
                      overflow: "visible", 
                      textOverflow: "unset", 
                      wordBreak: "break-word", 
                    }}
                    htmlFor="my-input"
                  >
                    Tobacco Planted Hectares
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      // label="Tobacco Hectares"
                      value={contractDetailsData?.tobaccoPlantedHectares}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </PaperContainer>
        </Box>
      </div>
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

export default ViewContractDetails;
